import { useContext } from 'react';
import { InboundContext } from '../../../../context/InboundContext';
import { FormGroup } from '../../../common';
import { Heading } from '../../../styledComponents';
import styles from '../FormContainer.module.css';

type OtherDetailsProps = {
  customMessage: string;
  setCustomMessage: React.Dispatch<React.SetStateAction<string>>;
};

export default function OtherDetails({ customMessage, setCustomMessage }: OtherDetailsProps) {
  const { inboundData, t } = useContext(InboundContext);

  if (inboundData?.formSetupPage.otherDetails) {
    return (
      <div className={styles.formSection}>
        <Heading as="h3" fontWeight="500" fontSize="16px" color="#353535" textTransform="uppercase">
          {t('otherDetailsHeader')}
        </Heading>
        <FormGroup
          id="otherDetails"
          name="otherDetails"
          label={t('otherDetailsSubTitle')}
          type="text"
          placeholder={t('otherDetailsPlaceholder')}
          value={customMessage}
          onChange={(e) => {
            if (e.target.value.length > 500) return;
            setCustomMessage(e.target.value);
          }}
          errorText=""
          displayAsTextArea
          rightLabel={`${customMessage.length}/500`}
        />
      </div>
    );
  }
  return null;
}
